module.exports = __webpack_public_path__ + "fonts/Roboto.52ee8b59.ttf";